// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PDFViewer-module__container___xr9xr {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 20px;
    gap: 20px;
    flex: 2;
    height: auto;
    background-color: #4E4B66;
    border-radius: 10px;
}

.PDFViewer-module__heading___E5kAB {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 45px;
    background-color: #6E7191;
    color: white;
    font-family: Montserrat;
    font-weight: 600;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 8%;
    text-align: center;
    text-transform: uppercase;
    border-radius: 12px;
}


.PDFViewer-module__contentWrapper___D2msM {
    display: flex;
    flex-direction: row;
    width: 100%;
}

.PDFViewer-module__sideBorder___mVdtI {
    background-color: #4E4B66;
}

.PDFViewer-module__pdfContainer___bZtze {
    flex: 1;
    position: relative;
    max-height: 750px;
    overflow: hidden;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
}

.PDFViewer-module__pageIndicator___mkcN3 {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 150px;
    height: 33px;
    bottom: 5px;
    right: 10px;
    background-color: #6E7191;
    color: #fff;
    padding: 5px 10px;
    border-radius: 10px;
    font-size: 14px;
    z-index: 10;
}
.PDFViewer-module__pageIndicator___mkcN3 img {
    width: 16px;
    height: 16px;
    margin-right: 4px;
    vertical-align: middle;
}
.PDFViewer-module__zoomControls___GvTrK {
    display: flex;
    gap: 8px;
    margin: 8px 0;
    align-items: center;
    color: #fff !important;
}
.PDFViewer-module__zoomControls___GvTrK > div > button{
    color: #fff;
}
.PDFViewer-module__errorState___Ij_RM {
    height: 100%;
    color: #d32f2f;
    background: #fff5f5;
    border: 1px solid #f5c2c2;
    border-radius: 4px;
    padding: 16px;
    text-align: center;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/pdfviewer/PDFViewer.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,aAAa;IACb,SAAS;IACT,OAAO;IACP,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,OAAO;IACP,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,WAAW;AACf;AACA;IACI,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;EACpB","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    padding: 20px;\n    gap: 20px;\n    flex: 2;\n    height: auto;\n    background-color: #4E4B66;\n    border-radius: 10px;\n}\n\n.heading {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 45px;\n    background-color: #6E7191;\n    color: white;\n    font-family: Montserrat;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 100%;\n    letter-spacing: 8%;\n    text-align: center;\n    text-transform: uppercase;\n    border-radius: 12px;\n}\n\n\n.contentWrapper {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n}\n\n.sideBorder {\n    background-color: #4E4B66;\n}\n\n.pdfContainer {\n    flex: 1;\n    position: relative;\n    max-height: 750px;\n    overflow: hidden;\n    border-top: 1px solid #ccc;\n    border-bottom: 1px solid #ccc;\n}\n\n.pageIndicator {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    width: 150px;\n    height: 33px;\n    bottom: 5px;\n    right: 10px;\n    background-color: #6E7191;\n    color: #fff;\n    padding: 5px 10px;\n    border-radius: 10px;\n    font-size: 14px;\n    z-index: 10;\n}\n.pageIndicator img {\n    width: 16px;\n    height: 16px;\n    margin-right: 4px;\n    vertical-align: middle;\n}\n.zoomControls {\n    display: flex;\n    gap: 8px;\n    margin: 8px 0;\n    align-items: center;\n    color: #fff !important;\n}\n.zoomControls > div > button{\n    color: #fff;\n}\n.errorState {\n    height: 100%;\n    color: #d32f2f;\n    background: #fff5f5;\n    border: 1px solid #f5c2c2;\n    border-radius: 4px;\n    padding: 16px;\n    text-align: center;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PDFViewer-module__container___xr9xr`,
	"heading": `PDFViewer-module__heading___E5kAB`,
	"contentWrapper": `PDFViewer-module__contentWrapper___D2msM`,
	"sideBorder": `PDFViewer-module__sideBorder___mVdtI`,
	"pdfContainer": `PDFViewer-module__pdfContainer___bZtze`,
	"pageIndicator": `PDFViewer-module__pageIndicator___mkcN3`,
	"zoomControls": `PDFViewer-module__zoomControls___GvTrK`,
	"errorState": `PDFViewer-module__errorState___Ij_RM`
};
export default ___CSS_LOADER_EXPORT___;
